import { AgentType, createThread, fetchThreads } from './threads'
import type { GetProjectAgentThreadsResponse, ProjectAgentNewThreadResponse } from './threads'

export async function fetchSearchAgentThreads(projectId: number): Promise<GetProjectAgentThreadsResponse> {
  return fetchThreads(projectId, AgentType.SearchAgent)
}

export async function createSearchAgentThread(
  projectId: number,
  title: string
): Promise<ProjectAgentNewThreadResponse> {
  return createThread(projectId, title, AgentType.SearchAgent)
}
